import { store } from '../../store/store';

export const getSpotifyUserId = (): string | null => {
  const state = store.getState();
  return state.profile.user?.id ?? state.auth.user?.id ?? null;
};

export const assertSpotifyUserId = (): string => {
  const userId = getSpotifyUserId();

  if (!userId) {
    throw new Error('Spotify user id is not available');
  }

  return userId;
};
